import { LANGUAGE_STORAGE_KEY } from '../../../../i18n/language';

class TencerAuthService {

    private static readonly TOKEN = 'token';
    private static readonly REFRESH_TOKEN = 'refresh_token';

    private static INSTANCE = new TencerAuthService();

    private _nextRoute: string;

    private constructor() {
        this._nextRoute = '';
    }

    public static getInstance(): TencerAuthService {
        return TencerAuthService.INSTANCE;
    }

    public authenticate(token: string): void {
        window.localStorage.setItem(TencerAuthService.TOKEN, token);
    }

    public authenticateRefreshToken(refresh_token: string): void {
        window.localStorage.setItem(TencerAuthService.REFRESH_TOKEN, refresh_token);
    }

    public isAuthenticated(): boolean {
        return !!window.localStorage.getItem(TencerAuthService.TOKEN);
    }

    public hasRefreshToken(): boolean {
        return !!window.localStorage.getItem(TencerAuthService.REFRESH_TOKEN);
    }

    public clear():void {
        const language = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
        window.localStorage.clear();
        if (language) {
            window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
        }
    }

    public saveNextRoute(nextRoute: string): void {
        this._nextRoute = nextRoute;
    }

    public nextRoute(): string {
        return this._nextRoute;
    }

}

export const TencerAuthServiceInstance = TencerAuthService.getInstance();
